import ITheme from "@/interfaces/iTheme";
import backgroundImageLightTheme from "@assets/themes/light/backgroundImageLightTheme.svg";

const COLOR_TEXT = '#001A53';

export class LightTheme implements ITheme
{
    static Id = 'light';
    id = LightTheme.Id;

    name = 'Light';

    colors = {
        application: '#FFFFFF',
        text: COLOR_TEXT,
        confirm: '#1976D2',
        confirmText: 'white',
        accent: '#1976D2',

        // Challenge card colors
        solved: '#808080',
        solvedText: '#000000DE',
        lockedText: COLOR_TEXT,
        unsolved: '#B3E5FC',
        unsolvedText: '#000000DE',
        noMoreAttempts: '#FBA6A6',
        noMoreAttemptsText: '#000000DE',
        disabled: '#B3E5FC',
        disabledText: '#000000DE',
        disabledIcon: '#C62828',

        windowBackground: '#FFF9',
        windowText: '#000',
        windowBorder: '#0000001F',

        activeTab: '#1976D2',
        dialogText: '#303030',
        dialogSuccessText: '#4CAF50',
        dialogFailureText: '#F44336',
        dialogIcon: '#1976D2',
        success: '#4CAF50',
        warning: '#FF9800',

        // Table
        tableHeaderActionButtons: '#666666',
        tableHeaderSelectAllButtons: '#1976D2',

        //settings and bulk select checkboxes 
        checkedFill: '#1976D2',
        checkedBorder: '#1976D2',

        // focus indicators
        focusVisibleIndicator:  'black',

        // the most common color from the background image with sufficient contrast
        backgroundImageColor: 'transparent',

        actionButtonBackground: 'white',
        actionButtonText: 'black',
    };

    fontFamily = "Blinker";
    landingFontFamily = "space_frigate";
    backgroundImage = backgroundImageLightTheme;
    isDark = false;
}
